export const pieAcademicProgress = Object.freeze({
  Unset: 0,
  Unavailable: 1,
  Pending: 2,
  Submitted: 3,
  Discussed: 4,
  Amended: 5,
  NotApply: 6,
});
